import {EventVerteiler} from "../../global/eventVerteiler";

import {LogoPoolController} from "../controllerModules/logoPoolController";
import {AILogoToUserAccountAdderProgress, KIlogoGenerationProgress} from "./KIlogoGenerationProgress";
import {KIOverlaySelectors, showKI_Image_Overlay} from "./KIOverlaySelectors";
import axios from "axios";
import {ProgressGETPoller} from "../job_progress/ProgressPoller";


export class LogoFromPromptGenerator {
    private static currentPrompt = "";
    private static currentPreset = "";

    public static init(logoPoolController: LogoPoolController) {
        $("#submit-prompt").on("click", () => LogoFromPromptGenerator.submitPrompt(logoPoolController))
    }

    private static submitPrompt(logoPoolController: LogoPoolController) {
        if (logoPoolController.model.user.getRemainingAILogoCredits() < 1) {
            EventVerteiler.broadcast("displayDialogEvent", {dialog: "ki_keine_credits"});
            return;
        }

        let prompt = (document.getElementById("ki_prompt") as HTMLInputElement).value.trim();
        if (prompt === "") {
            return;
        }
        LogoFromPromptGenerator.currentPrompt = prompt;
        LogoFromPromptGenerator.currentPreset = (document.getElementById("ki_style") as HTMLInputElement).value;
        if (LogoFromPromptGenerator.currentPreset === '') {
            EventVerteiler.broadcast("displayDialogEvent", {dialog: "ki_keine_stilrichtung"});
        } else {
            LogoFromPromptGenerator.generateLogoFromPrompt(prompt, LogoFromPromptGenerator.currentPreset);
            EventVerteiler.broadcast("IncrementAICreditsUsed");
        }
    }

    public static generateLogoFromPrompt(prompt:string, preset:string) {
        showKI_Image_Overlay(KIOverlaySelectors.LOADING)
        LogoFromPromptGenerator.sendPromptToBackend(prompt, preset);
        KIlogoGenerationProgress.progress("initializing...");
    }

    public static resolveAILogoGeneration(success: boolean, id:number, imagetextBase64: string, errorMessage = "") {
        if (!success) {
            EventVerteiler.broadcast("displayDialogEvent", {dialog: errorMessage});
            return;
        }
        KIlogoGenerationProgress.finished(LogoFromPromptGenerator.currentPrompt, id, imagetextBase64, LogoFromPromptGenerator.currentPreset);
        showKI_Image_Overlay(KIOverlaySelectors.RESULT);
    }

    private static sendPromptToBackend(prompt:string, preset:string) {
        axios.get("/konfigurator_php/ki_logos/start_ki_logogeneration.php?prompt="+ prompt + "&preset=" + preset).then(response=>{
            if(isNaN(parseInt(response.data))) {
                alert(response.data);
                return;
            }
            const logogenerationID = parseInt(response.data);
            const poller = new ProgressGETPoller(
                "/konfigurator_php/ki_logos/getKILogoGenerationProgress.php?id="+logogenerationID,
                    progress=> KIlogoGenerationProgress.progress(progress)
            );
            poller.pollUntilFinished()
                .then(result=>LogoFromPromptGenerator.resolveAILogoGeneration(!result.error, logogenerationID, result.imageBase64, result.errorstring))
                .catch(result=>LogoFromPromptGenerator.resolveAILogoGeneration(true, logogenerationID, "", result.errorstring))
        });
    }
}

export class AILogoToUserAccountAdder {
    private static getURLForUpscale(id:number, preset:string) {
        return "/konfigurator_php/ki_logos/putAILogosInLogoBib.php?id=" + id+"&preset="+preset;
    }

    public static putImagesIntoLogoBibliothek(id:number, preset:string) {
        showKI_Image_Overlay(KIOverlaySelectors.ADDING_TO_LIBRARY);
        AILogoToUserAccountAdderProgress.init();
        (document.getElementById("ailogogeneration_scriptcontainer")as HTMLIFrameElement).src=AILogoToUserAccountAdder.getURLForUpscale(id, preset);
        (window as any).ai_upscaleProgress = (progress:string)=>AILogoToUserAccountAdderProgress.progress(progress);
        (window as any).ai_upscaleFinished = (url1:string, url2:string)=>AILogoToUserAccountAdderProgress.finished(url1, url2);
    }
}
